module.exports = __webpack_public_path__ + "static/media/left-chevron.11220a61.svg";